// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/background-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/sound-off_dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/images/sound-on_dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/images/theme-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/images/cross_dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/images/background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/images/sound-off.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/images/sound-on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/images/theme-light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/images/cross.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sofia+Sans:wght@300&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Stick&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
:root {
  font-size: 10px; }

* {
  box-sizing: border-box; }

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */ }

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
  font-family: "Stick", sans-serif; }

/**
 * Render the \`main\` element consistently in IE.
 */
main {
  display: block; }

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 3.2em;
  margin: 0.67em 0; }

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */ }

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */ }

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent; }

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */ }

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder; }

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */ }

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%; }

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline; }

sub {
  bottom: -0.25em; }

sup {
  top: -0.5em; }

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none; }

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */ }

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible; }

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none; }

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0; }

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText; }

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em; }

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */ }

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline; }

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto; }

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */ }

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; }

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */ }

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */ }

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block; }

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item; }

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none; }

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none; }

html {
  --color-cell-primary: #e097b2;
  --color-cell-additional: #872d49;
  --color-cell-hover: #893655;
  --color-back: #e3e3d9;
  --color-shadow: #ffadcc;
  --color-modal: #ffffff;
  --shadow-primary: -5px -5px 44px \$color-shadow;
  --shadow-additional: 0px 0px 45px 0px \$color-cell-additional inset;
  --shadow-button: 0px 0px 10px 0px #84264437 inset;
  --shadow-cell: 0px 0px 45px 0px #842644ce; }

@media (max-width: 768px) {
  :root {
    font-size: 1.5vw; } }

@media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
  :root {
    font-size: 1.5vh; } }

html[data-theme="dark"] {
  --color-cell-primary: #7e6282;
  --color-cell-additional: #36002b;
  --color-cell-hover: #36002b;
  --color-back: #a89da8;
  --color-shadow: #2a2a2a;
  --color-modal: #ffffff;
  --shadow-game-field: -5px -5px 44px \$color-shadow;
  --shadow-additional: 0px 0px 45px 0px \$color-cell-additional inset;
  --shadow-button: 0px 0px 10px 0px #1a08086e inset;
  --shadow-cell: 0px 0px 45px 0px #842644ce; }
  html[data-theme="dark"] .background {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }
  html[data-theme="dark"] .button__audio_off {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }
  html[data-theme="dark"] .button__audio_on {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
  html[data-theme="dark"] .button__theme_dark {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }
  html[data-theme="dark"] .cell_crossed {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-color: var(--color-cell-primary); }

.gameField, .modal__window {
  opacity: 0.5;
  border-radius: 2rem;
  box-shadow: var(--shadow-primary); }

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh; }
  @media (max-width: 768px) {
    .main {
      height: 100svh; } }
  @media (max-width: 768px) and (orientation: landscape) {
    .main {
      width: 100dvw;
      margin: 30px 0; } }
  @media screen and (orientation: portrait) and (min-width: 431px) and (max-width: 1193px) {
    .main {
      justify-content: end; } }
  @media screen and (min-height: 1025px) {
    .main {
      justify-content: center; } }

.background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  height: 100%;
  width: 100%;
  opacity: 0.9;
  top: 0;
  position: fixed;
  z-index: -1; }

.main__header {
  display: flex;
  gap: 2rem; }

.main__header_win {
  text-shadow: 1px -1px #ffffff;
  scale: 1.2;
  transition: all 1s cubic-bezier(0, -0.27, 1, 1.27); }

.menu {
  display: grid;
  row-gap: 2rem;
  position: fixed;
  top: 2vh;
  left: 2vw; }
  @media screen and (orientation: portrait) and (max-width: 1193px) {
    .menu {
      width: 65vw;
      left: 4vw; } }

.menu__buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  width: 22.4rem; }
  @media screen and (orientation: portrait) and (max-width: 1193px) {
    .menu__buttons {
      width: auto; } }

.menu__templates {
  display: flex;
  flex-direction: column;
  gap: 2rem; }
  @media screen and (orientation: portrait) and (max-width: 1193px) {
    .menu__templates {
      width: 100%;
      display: grid;
      grid-template-columns: 0.5fr 2fr; } }

.header__text,
.header__timer {
  color: var(--color-cell-hover);
  transition: all 1s cubic-bezier(0, -0.27, 1, 1.27); }

.templates__sizes,
.templates__names,
.templates__wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
  opacity: 1;
  transition: opacity 0.3s; }

.templates__wrapper {
  position: relative; }
  @media screen and (orientation: portrait) and (max-width: 1193px) {
    .templates__wrapper {
      overflow-y: hidden; } }

.templates__sizes_hidden,
.templates__names_hidden {
  position: absolute;
  width: 100%;
  opacity: 0;
  pointer-events: none; }

.templates__wrapper_hidden {
  opacity: 0; }

@media screen and (orientation: portrait) and (max-width: 1193px) {
  .templates__sizes,
  .templates__names {
    flex-direction: row;
    overflow-y: hidden; } }

.button {
  cursor: pointer;
  transition: all 0.3s; }
  @media (hover: hover) {
    .button:hover {
      transform: scale(1.2); }
    .button:active {
      transform: scale(1); } }

.settings {
  position: fixed;
  top: 2vh;
  right: 2vw;
  display: flex;
  gap: 2rem; }

.button__audio_off {
  height: 5.6rem;
  width: 5.6rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

.button__audio_on {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }

.button__theme_light {
  height: 5.6rem;
  width: 5.6rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }

.button__menu,
.button__templates {
  height: 5.6rem;
  width: 6.22222rem;
  background: none;
  border-radius: 100px;
  color: var(--color-cell-additional);
  border: 0.2rem solid var(--color-cell-additional);
  display: flex;
  justify-content: center;
  align-items: center; }
  .button__menu:active,
  .button__templates:active {
    box-shadow: var(--shadow-button); }

.button__templates {
  width: 100%; }
  @media (hover: hover) {
    .button__templates:hover {
      transform: scale(1.1); }
    .button__templates:active {
      transform: scale(1); } }

.divider-vertical {
  height: 67.2rem;
  width: 1px;
  background: var(--color-back); }

.divider-horizontal {
  height: 1px;
  width: 67.2rem;
  background: var(--color-back); }

.cell {
  height: 11.2rem;
  width: 11.2rem;
  background: var(--color-cell-primary);
  border: 0.2rem solid var(--color-cell-additional);
  cursor: pointer;
  position: relative;
  transition: all 0.4s ease; }
  @media (hover: hover) {
    .cell:hover {
      z-index: 2;
      transform: scale(1.1);
      outline: 0.2rem solid var(--color-back);
      box-shadow: var(--shadow-cell); }
    .cell:active {
      transform: scale(1); }
    .cell:not(:hover) {
      z-index: 1; } }
  @media screen and (max-width: 768px) {
    .cell {
      height: 14vw; } }
  @media screen and (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .cell {
      height: 14vh;
      width: 9vw; } }

.cell_pressed {
  background: var(--color-cell-hover);
  outline: 0.2rem solid var(--color-back); }

.cell_crossed {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-color: var(--color-cell-primary); }
  .cell_crossed:hover {
    box-shadow: none; }

.cell_clue {
  height: 11.2rem;
  width: 11.2rem;
  background: none;
  border: 1px solid var(--color-back);
  text-align: center;
  color: var(--color-back);
  display: inline-grid;
  align-items: center; }
  @media screen and (max-width: 768px) {
    .cell_clue {
      height: 14vw; } }
  @media screen and (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .cell_clue {
      height: 14vh;
      width: 100%; } }

.horizontal {
  display: inline-flex;
  justify-content: space-around; }

.gameField {
  height: 67.2rem;
  width: 67.2rem;
  background: var(--color-cell-hover);
  display: flex;
  align-items: end;
  justify-content: right;
  position: relative;
  margin: 3rem;
  transition: all 0.3s; }
  @media (orientation: portrait) and (max-width: 768px) {
    .gameField {
      width: 80vw;
      height: auto; } }
  @media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .gameField {
      height: 90dvh; } }
  @media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .gameField {
      height: 90dvh;
      width: 54vw; } }

.gameField_closed {
  opacity: 0; }

.gameField__cells {
  border-collapse: collapse;
  border: 0.5rem solid var(--color-back); }
  @media screen and (max-width: 768px) {
    .gameField__cells {
      width: 85%;
      position: absolute; } }
  @media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .gameField__cells {
      width: unset; } }

.gameField__clues-wrapper {
  position: absolute;
  z-index: -1;
  max-height: 100%; }
  @media (max-width: 768px) {
    .gameField__clues-wrapper {
      position: unset; } }
  @media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .gameField__clues-wrapper {
      width: 100%; } }

.gameField__clues {
  border-collapse: collapse;
  font-size: 3rem; }
  @media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
    .gameField__clues {
      width: 100%; } }

@media (orientation: portrait) and (max-width: 768px) {
  .gameField__clues tr {
    width: 80vw;
    display: flex; } }

@media (orientation: landscape) and (max-width: 1024px) and (max-height: 768px) {
  .gameField__clues tr {
    display: flex; } }

.modal {
  display: none; }

.modal_open {
  display: block; }

.modal__overlay {
  cursor: pointer;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8); }

.modal__window {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 67.2rem;
  width: 67.2rem;
  background: var(--color-modal);
  display: flex;
  align-items: center;
  justify-content: left;
  flex-direction: column;
  color: var(--color-cell-hover); }

.window__line {
  display: flex;
  justify-content: space-around;
  width: 100%; }

.window__line_main {
  display: flex;
  justify-content: space-around;
  width: 100%; }
`, "",{"version":3,"sources":["webpack://./src/sass/base/_normalize.scss","webpack://./src/sass/main.scss","webpack://./src/sass/abstract/_constants.scss","webpack://./src/sass/base/_mobile-reset.scss","webpack://./src/sass/themes/_theme.scss","webpack://./src/sass/abstract/_placeholders.scss","webpack://./src/sass/pages/_home.scss","webpack://./src/sass/abstract/_mixins.scss","webpack://./src/sass/components/_menu.scss","webpack://./src/sass/components/_header.scss","webpack://./src/sass/components/_templates.scss","webpack://./src/sass/components/_button.scss","webpack://./src/sass/components/_divider.scss","webpack://./src/sass/components/_cell.scss","webpack://./src/sass/components/_gameField.scss","webpack://./src/sass/components/_modal.scss"],"names":[],"mappings":"AAAA,2EAAA;AAEA;+ECA+E;ADG/E;EACE,eAAe,EAAA;;AAGjB;EACE,sBAAsB,EAAA;;AAGxB;;;ECCE;ADIF;EACE,iBAAiB;EAAE,MAAA;EACnB,8BAA8B;EAAE,MAAA,EAAO;;AAGzC;+ECD+E;ADI/E;;ECDE;ADKF;EACE,SAAS;EAET,gCAAgC,EAAA;;AAGlC;;ECJE;ADQF;EACE,cAAc,EAAA;;AAGhB;;;ECLE;ADUF;EACE,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;+ECT+E;ADY/E;;;ECRE;ADaF;EACE,uBAAuB;EAAE,MAAA;EACzB,SAAS;EAAE,MAAA;EACX,iBAAiB;EAAE,MAAA,EAAO;;AAG5B;;;ECPE;ADYF;EACE,iCAAiC;EAAE,MAAA;EACnC,cAAc;EAAE,MAAA,EAAO;;AAGzB;+ECT+E;ADY/E;;ECTE;ADaF;EACE,6BAA6B,EAAA;;AAG/B;;;ECVE;ADeF;EACE,mBAAmB;EAAE,MAAA;EACrB,0BAA0B;EAAE,MAAA;EAC5B,iCAAiC;EAAE,MAAA,EAAO;;AAG5C;;ECVE;ADcF;;EAEE,mBAAmB,EAAA;;AAGrB;;;ECXE;ADgBF;;;EAGE,iCAAiC;EAAE,MAAA;EACnC,cAAc;EAAE,MAAA,EAAO;;AAGzB;;ECZE;ADgBF;EACE,cAAc,EAAA;;AAGhB;;;ECbE;ADkBF;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB,EAAA;;AAG1B;EACE,eAAe,EAAA;;AAGjB;EACE,WAAW,EAAA;;AAGb;+ECnB+E;ADsB/E;;ECnBE;ADuBF;EACE,kBAAkB,EAAA;;AAGpB;+ECtB+E;ADyB/E;;;ECrBE;AD0BF;;;;;EAKE,oBAAoB;EAAE,MAAA;EACtB,eAAe;EAAE,MAAA;EACjB,iBAAiB;EAAE,MAAA;EACnB,SAAS;EAAE,MAAA,EAAO;;AAGpB;;;ECnBE;ADwBF;;EAEE,MAAA;EACA,iBAAiB,EAAA;;AAGnB;;;ECrBE;AD0BF;;EAEE,MAAA;EACA,oBAAoB,EAAA;;AAGtB;;ECxBE;AD4BF;;;;EAIE,0BAA0B,EAAA;;AAG5B;;EC1BE;AD8BF;;;;EAIE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;;EC5BE;ADgCF;;;;EAIE,8BAA8B,EAAA;;AAGhC;;EC9BE;ADkCF;EACE,8BAA8B,EAAA;;AAGhC;;;;;EC7BE;ADoCF;EACE,sBAAsB;EAAE,MAAA;EACxB,cAAc;EAAE,MAAA;EAChB,cAAc;EAAE,MAAA;EAChB,eAAe;EAAE,MAAA;EACjB,UAAU;EAAE,MAAA;EACZ,mBAAmB;EAAE,MAAA,EAAO;;AAG9B;;EC5BE;ADgCF;EACE,wBAAwB,EAAA;;AAG1B;;EC9BE;ADkCF;EACE,cAAc,EAAA;;AAGhB;;;EC/BE;AACF;;EDqCE,sBAAsB;EAAE,MAAA;EACxB,UAAU;EAAE,MAAA,EAAO;;AAGrB;;EChCE;AACF;;EDqCE,YAAY,EAAA;;AAGd;;;ECjCE;AACF;EDsCE,6BAA6B;EAAE,MAAA;EAC/B,oBAAoB;EAAE,MAAA,EAAO;;AAG/B;;EClCE;AACF;EDsCE,wBAAwB,EAAA;;AAG1B;;;ECnCE;ADwCF;EACE,0BAA0B;EAAE,MAAA;EAC5B,aAAa;EAAE,MAAA,EAAO;;AAGxB;+ECrC+E;ADwC/E;;ECrCE;ADyCF;EACE,cAAc,EAAA;;AAGhB;;ECvCE;AD2CF;EACE,kBAAkB,EAAA;;AAGpB;+EC1C+E;AD6C/E;;EC1CE;AD8CF;EACE,aAAa,EAAA;;AAGf;;EC5CE;AACF;EDgDE,aAAa,EAAA;;AArVf;EEjBE,6BAAqB;EACrB,gCAAwB;EACxB,2BAAmB;EACnB,qBAAa;EACb,uBAAe;EACf,sBAAc;EACd,8CAAiB;EACjB,kEAAoB;EACpB,iDAAgB;EAChB,yCAAc,EAAA;;ACTd;EHIF;IGHI,gBAAgB,EAAA,EAMnB;;AAHC;EHAF;IGCI,gBAAgB,EAAA,EAEnB;;ACRD;EACE,6BAAqB;EACrB,gCAAwB;EACxB,2BAAmB;EACnB,qBAAa;EACb,uBAAe;EACf,sBAAc;EACd,iDAAoB;EACpB,kEAAoB;EACpB,iDAAgB;EAChB,yCAAc,EAAA;EAVhB;IAaI,yDAA2D,EAAA;EAb/D;IAiBI,mDAAoD,EAAA;EAjBxD;IAqBI,mDAAmD,EAAA;EArBvD;IAyBI,mDAAgD,EAAA;EAzBpD;IA6BI,mDAAgD;IAChD,2CFhByC,EAAA;;AGJ7C;EACE,YAAY;EACZ,mBHkBsB;EGjBtB,iCHK8C,EAAA;;AIlBhD;ECOE,aAAa;EACb,mBAFsC;EAGtC,uBAHgE;EDJhE,sBAAsB;EACtB,aJkBiB,EAAA;EIhBjB;IALF;MAMI,cAAc,EAAA,EAejB;EAZC;IATF;MAUI,aAAa;MACb,cAAc,EAAA,EAUjB;EAPC;IAdF;MAeI,oBAAoB,EAAA,EAMvB;EAHC;IAlBF;MAmBI,uBAAuB,EAAA,EAE1B;;AAED;EACE,yDAAsD;EACtD,sBAAsB;EACtB,YAAY;EACZ,WAAW;EAEX,YAAY;EACZ,MAAM;EACN,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,6BAA6B;EAC7B,UAAY;EACZ,kDAAkD,EAAA;;AE3CpD;EACE,aAAa;EACb,aAAa;EAEb,eAAe;EACf,QAAQ;EACR,SAAS,EAAA;EAET;IARF;MASI,WAAW;MACX,SAAS,EAAA,EAEZ;;AAED;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAqB,EAAA;EAErB;IAPF;MAQI,WAAW,EAAA,EAEd;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EAET;IALF;MAMI,WAAW;MACX,aAAa;MACb,gCAAgC,EAAA,EAEnC;;ACpCD;;EAEE,8BPY2C;EOX3C,kDAAkD,EAAA;;ACHpD;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,wBAAwB,EAAA;;AAG1B;EACE,kBAAkB,EAAA;EAClB;IAFF;MAGI,kBAAkB,EAAA,EAErB;;AAED;;EAEE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,oBAAoB,EAAA;;AAEtB;EACE,UAAU,EAAA;;AAKV;EAFF;;IAGI,mBAAmB;IACnB,kBAAkB,EAAA,EAErB;;ACnCD;EACE,eAAe;EACf,oBAAoB,EAAA;EAEpB;IAJF;MAMM,qBAAqB,EAAA;IAN3B;MAUM,mBAAmB,EAAA,EACpB;;AAIL;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,aAAa;EACb,SAAS,EAAA;;AAGX;EJtBE,cIwBgB;EJvBhB,aIwBgB;EJvBhB,mDIwBqC,EAAA;;AAIvC;EACE,mDAA8C,EAAA;;AAGhD;EJlCE,cIoCgB;EJnChB,aIoCgB;EJnChB,mDIoCuC,EAAA;;AAIzC;;EJ1CE,cI4CsC;EJ3CtC,iBI2CwD;EJ1CxD,gBAHiD;EI+CjD,oBAAoB;EACpB,mCTlC2C;ESmC3C,iDTnC2C;ESqC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EAVrB;;IAaI,gCTtC4C,EAAA;;AS0ChD;EACE,WAAW,EAAA;EAEX;IAHF;MAKM,qBAAqB,EAAA;IAL3B;MASM,mBAAmB,EAAA,EACpB;;ACtEL;ELCE,eL2BuB;EK1BvB,UKD6C;ELE7C,6BLW2C,EAAA;;AUV7C;ELHE,WKI2B;ELH3B,cL0BuB;EKzBvB,6BLW2C,EAAA;;AWd7C;ENCE,eL0BiB;EKzBjB,cLyBiB;EKxBjB,qCLW2C;EWX3C,iDXW2C;EWV3C,eAAe;EACf,kBAAkB;EAClB,yBAAyB,EAAA;EAEzB;IARF;MAUM,UAAU;MACV,qBAAqB;MACrB,uCXEuC;MWDvC,8BXK0C,EAAA;IWlBhD;MAiBM,mBAAqB,EAAA;IAjB3B;MAqBM,UAAU,EAAA,EACX;EAGH;IAzBF;MA0BI,YAAY,EAAA,EAOf;EAJC;IA7BF;MA8BI,YAAY;MACZ,UAAU,EAAA,EAEb;;AAED;EACE,mCXtB2C;EWuB3C,uCXvB2C,EAAA;;AW0B7C;EACE,mDAA2C;EAC3C,2CX5B2C,EAAA;EW0B7C;IAKI,gBAAgB,EAAA;;AAIpB;ENhDE,eL0BiB;EKzBjB,cLyBiB;EKxBjB,gBAHiD;EMmDjD,mCXrC2C;EWsC3C,kBAAkB;EAClB,wBXvC2C;EWyC3C,oBAAoB;EACpB,mBAAmB,EAAA;EAEnB;IATF;MAUI,YAAY,EAAA,EAOf;EAJC;IAbF;MAcI,YAAY;MACZ,WAAW,EAAA,EAEd;;AAED;EACE,oBAAoB;EACpB,6BAA6B,EAAA;;ACtE/B;EPCE,eL2BuB;EK1BvB,cL0BuB;EKzBvB,mCLW2C;EKP3C,aAAa;EACb,gBOFyB;EPGzB,sBOHgC;EAGhC,kBAAkB;EAClB,YAAY;EACZ,oBAAoB,EAAA;EAEpB;IAbF;MAcI,WAAW;MACX,YAAY,EAAA,EAWf;EARC;IAlBF;MAmBI,aAAa,EAAA,EAOhB;EAJC;IAtBF;MAuBI,aAAa;MACb,WAAW,EAAA,EAEd;;AAED;EACE,UAAU,EAAA;;AAGZ;EACE,yBAAyB;EACzB,sCZpB2C,EAAA;EYsB3C;IAJF;MAKI,UAAU;MACV,kBAAkB,EAAA,EAKrB;EAHC;IARF;MASI,YAAY,EAAA,EAEf;;AAED;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;EAEhB;IALF;MAMI,eAAe,EAAA,EAMlB;EAHC;IATF;MAUI,WAAW,EAAA,EAEd;;AAED;EACE,yBAAyB;EACzB,eAAe,EAAA;EAEf;IAJF;MAKI,WAAW,EAAA,EAEd;;AAED;EACE;IACE,WAAW;IACX,aAAa,EAAA,EACd;;AAGH;EANE;IAQE,aAAa,EAAA,EACd;;AC9EH;EACE,aAAa,EAAA;;AAGf;EACE,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,8BAA8B,EAAA;;AAGhC;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;ERrBhC,eL2BuB;EK1BvB,cL0BuB;EKzBvB,8BLW2C;EKP3C,aAAa;EACb,mBQkB4B;ERjB5B,qBQiBkC;EAClC,sBAAsB;EAGtB,8BbhB2C,EAAA;;AamB7C;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW,EAAA","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\r\n\r\n/* Document\r\n   ========================================================================== */\r\n\r\n:root {\r\n  font-size: 10px;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/**\r\n * 1. Correct the line height in all browsers.\r\n * 2. Prevent adjustments of font size after orientation changes in iOS.\r\n */\r\n\r\nhtml {\r\n  line-height: 1.15; /* 1 */\r\n  -webkit-text-size-adjust: 100%; /* 2 */\r\n}\r\n\r\n/* Sections\r\n   ========================================================================== */\r\n\r\n/**\r\n * Remove the margin in all browsers.\r\n */\r\n\r\nbody {\r\n  margin: 0;\r\n  // font-family: \"Sofia Sans\", sans-serif;\r\n  font-family: \"Stick\", sans-serif;\r\n}\r\n\r\n/**\r\n * Render the `main` element consistently in IE.\r\n */\r\n\r\nmain {\r\n  display: block;\r\n}\r\n\r\n/**\r\n * Correct the font size and margin on `h1` elements within `section` and\r\n * `article` contexts in Chrome, Firefox, and Safari.\r\n */\r\n\r\nh1 {\r\n  font-size: 3.2em;\r\n  margin: 0.67em 0;\r\n}\r\n\r\n/* Grouping content\r\n   ========================================================================== */\r\n\r\n/**\r\n * 1. Add the correct box sizing in Firefox.\r\n * 2. Show the overflow in Edge and IE.\r\n */\r\n\r\nhr {\r\n  box-sizing: content-box; /* 1 */\r\n  height: 0; /* 1 */\r\n  overflow: visible; /* 2 */\r\n}\r\n\r\n/**\r\n * 1. Correct the inheritance and scaling of font size in all browsers.\r\n * 2. Correct the odd `em` font sizing in all browsers.\r\n */\r\n\r\npre {\r\n  font-family: monospace, monospace; /* 1 */\r\n  font-size: 1em; /* 2 */\r\n}\r\n\r\n/* Text-level semantics\r\n   ========================================================================== */\r\n\r\n/**\r\n * Remove the gray background on active links in IE 10.\r\n */\r\n\r\na {\r\n  background-color: transparent;\r\n}\r\n\r\n/**\r\n * 1. Remove the bottom border in Chrome 57-\r\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\r\n */\r\n\r\nabbr[title] {\r\n  border-bottom: none; /* 1 */\r\n  text-decoration: underline; /* 2 */\r\n  text-decoration: underline dotted; /* 2 */\r\n}\r\n\r\n/**\r\n * Add the correct font weight in Chrome, Edge, and Safari.\r\n */\r\n\r\nb,\r\nstrong {\r\n  font-weight: bolder;\r\n}\r\n\r\n/**\r\n * 1. Correct the inheritance and scaling of font size in all browsers.\r\n * 2. Correct the odd `em` font sizing in all browsers.\r\n */\r\n\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: monospace, monospace; /* 1 */\r\n  font-size: 1em; /* 2 */\r\n}\r\n\r\n/**\r\n * Add the correct font size in all browsers.\r\n */\r\n\r\nsmall {\r\n  font-size: 80%;\r\n}\r\n\r\n/**\r\n * Prevent `sub` and `sup` elements from affecting the line height in\r\n * all browsers.\r\n */\r\n\r\nsub,\r\nsup {\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  position: relative;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -0.25em;\r\n}\r\n\r\nsup {\r\n  top: -0.5em;\r\n}\r\n\r\n/* Embedded content\r\n   ========================================================================== */\r\n\r\n/**\r\n * Remove the border on images inside links in IE 10.\r\n */\r\n\r\nimg {\r\n  border-style: none;\r\n}\r\n\r\n/* Forms\r\n   ========================================================================== */\r\n\r\n/**\r\n * 1. Change the font styles in all browsers.\r\n * 2. Remove the margin in Firefox and Safari.\r\n */\r\n\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea {\r\n  font-family: inherit; /* 1 */\r\n  font-size: 100%; /* 1 */\r\n  line-height: 1.15; /* 1 */\r\n  margin: 0; /* 2 */\r\n}\r\n\r\n/**\r\n * Show the overflow in IE.\r\n * 1. Show the overflow in Edge.\r\n */\r\n\r\nbutton,\r\ninput {\r\n  /* 1 */\r\n  overflow: visible;\r\n}\r\n\r\n/**\r\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\r\n * 1. Remove the inheritance of text transform in Firefox.\r\n */\r\n\r\nbutton,\r\nselect {\r\n  /* 1 */\r\n  text-transform: none;\r\n}\r\n\r\n/**\r\n * Correct the inability to style clickable types in iOS and Safari.\r\n */\r\n\r\nbutton,\r\n[type=\"button\"],\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  -webkit-appearance: button;\r\n}\r\n\r\n/**\r\n * Remove the inner border and padding in Firefox.\r\n */\r\n\r\nbutton::-moz-focus-inner,\r\n[type=\"button\"]::-moz-focus-inner,\r\n[type=\"reset\"]::-moz-focus-inner,\r\n[type=\"submit\"]::-moz-focus-inner {\r\n  border-style: none;\r\n  padding: 0;\r\n}\r\n\r\n/**\r\n * Restore the focus styles unset by the previous rule.\r\n */\r\n\r\nbutton:-moz-focusring,\r\n[type=\"button\"]:-moz-focusring,\r\n[type=\"reset\"]:-moz-focusring,\r\n[type=\"submit\"]:-moz-focusring {\r\n  outline: 1px dotted ButtonText;\r\n}\r\n\r\n/**\r\n * Correct the padding in Firefox.\r\n */\r\n\r\nfieldset {\r\n  padding: 0.35em 0.75em 0.625em;\r\n}\r\n\r\n/**\r\n * 1. Correct the text wrapping in Edge and IE.\r\n * 2. Correct the color inheritance from `fieldset` elements in IE.\r\n * 3. Remove the padding so developers are not caught out when they zero out\r\n *    `fieldset` elements in all browsers.\r\n */\r\n\r\nlegend {\r\n  box-sizing: border-box; /* 1 */\r\n  color: inherit; /* 2 */\r\n  display: table; /* 1 */\r\n  max-width: 100%; /* 1 */\r\n  padding: 0; /* 3 */\r\n  white-space: normal; /* 1 */\r\n}\r\n\r\n/**\r\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\r\n */\r\n\r\nprogress {\r\n  vertical-align: baseline;\r\n}\r\n\r\n/**\r\n * Remove the default vertical scrollbar in IE 10+.\r\n */\r\n\r\ntextarea {\r\n  overflow: auto;\r\n}\r\n\r\n/**\r\n * 1. Add the correct box sizing in IE 10.\r\n * 2. Remove the padding in IE 10.\r\n */\r\n\r\n[type=\"checkbox\"],\r\n[type=\"radio\"] {\r\n  box-sizing: border-box; /* 1 */\r\n  padding: 0; /* 2 */\r\n}\r\n\r\n/**\r\n * Correct the cursor style of increment and decrement buttons in Chrome.\r\n */\r\n\r\n[type=\"number\"]::-webkit-inner-spin-button,\r\n[type=\"number\"]::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n/**\r\n * 1. Correct the odd appearance in Chrome and Safari.\r\n * 2. Correct the outline style in Safari.\r\n */\r\n\r\n[type=\"search\"] {\r\n  -webkit-appearance: textfield; /* 1 */\r\n  outline-offset: -2px; /* 2 */\r\n}\r\n\r\n/**\r\n * Remove the inner padding in Chrome and Safari on macOS.\r\n */\r\n\r\n[type=\"search\"]::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n/**\r\n * 1. Correct the inability to style clickable types in iOS and Safari.\r\n * 2. Change font properties to `inherit` in Safari.\r\n */\r\n\r\n::-webkit-file-upload-button {\r\n  -webkit-appearance: button; /* 1 */\r\n  font: inherit; /* 2 */\r\n}\r\n\r\n/* Interactive\r\n   ========================================================================== */\r\n\r\n/*\r\n * Add the correct display in Edge, IE 10+, and Firefox.\r\n */\r\n\r\ndetails {\r\n  display: block;\r\n}\r\n\r\n/*\r\n * Add the correct display in all browsers.\r\n */\r\n\r\nsummary {\r\n  display: list-item;\r\n}\r\n\r\n/* Misc\r\n   ========================================================================== */\r\n\r\n/**\r\n * Add the correct display in IE 10+.\r\n */\r\n\r\ntemplate {\r\n  display: none;\r\n}\r\n\r\n/**\r\n * Add the correct display in IE 10.\r\n */\r\n\r\n[hidden] {\r\n  display: none;\r\n}\r\n\r\n","@import \"base/normalize\";\r\n@import \"abstract/constants\";\r\n@import \"base/mobile-reset\";\r\n\r\n@import \"abstract/fonts\";\r\n@import \"themes/theme\";\r\n\r\n@import \"abstract/mixins\";\r\n@import \"abstract/placeholders\";\r\n@import \"pages/home\";\r\n@import \"components/menu\";\r\n@import \"components/header\";\r\n@import \"components/templates\";\r\n@import \"components/button\";\r\n@import \"components/divider\";\r\n@import \"components/cell\";\r\n@import \"components/gameField\";\r\n@import \"components/modal\";\r\n\r\n","html {\r\n  --color-cell-primary: #e097b2;\r\n  --color-cell-additional: #872d49;\r\n  --color-cell-hover: #893655;\r\n  --color-back: #e3e3d9;\r\n  --color-shadow: #ffadcc;\r\n  --color-modal: #ffffff;\r\n  --shadow-primary: -5px -5px 44px $color-shadow;\r\n  --shadow-additional: 0px 0px 45px 0px $color-cell-additional inset;\r\n  --shadow-button: 0px 0px 10px 0px #84264437 inset;\r\n  --shadow-cell: 0px 0px 45px 0px #842644ce;\r\n}\r\n\r\n@function getColor($color-name) {\r\n  @return var(--color-#{$color-name});\r\n}\r\n\r\n@function getShadow($shadow-name) {\r\n  @return var(--shadow-#{$shadow-name});\r\n}\r\n\r\n$height-page: 100vh;\r\n$width-page: 100vw;\r\n\r\n$border-table: 0.5rem;\r\n$border-cell: 0.2rem;\r\n\r\n$size-cell: 11.2rem;\r\n$size-game-field: 67.2rem;\r\n$size-divider: $size-game-field - $size-cell + $border-table;\r\n$radius-game-field: 2rem;\r\n\r\n// Breakpoints\r\n$content-width: 1193px;\r\n$tablet-landscape-width: 1024px;\r\n$tablet-width: 768px;\r\n$mobile-big-width: 431px;\r\n$mobile-big-landscape-height: 768px;\r\n\r\n",":root {\r\n  @media (max-width: $tablet-width) {\r\n    font-size: 1.5vw;\r\n  }\r\n\r\n  @media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    font-size: 1.5vh;\r\n  }\r\n}\r\n","html[data-theme=\"dark\"] {\r\n  --color-cell-primary: #7e6282;\r\n  --color-cell-additional: #36002b;\r\n  --color-cell-hover: #36002b;\r\n  --color-back: #a89da8;\r\n  --color-shadow: #2a2a2a;\r\n  --color-modal: #ffffff;\r\n  --shadow-game-field: -5px -5px 44px $color-shadow;\r\n  --shadow-additional: 0px 0px 45px 0px $color-cell-additional inset;\r\n  --shadow-button: 0px 0px 10px 0px #1a08086e inset;\r\n  --shadow-cell: 0px 0px 45px 0px #842644ce;\r\n\r\n  .background {\r\n    background-image: url(../assets/images/background-dark.jpg);\r\n  }\r\n\r\n  .button__audio_off {\r\n    background: url(../assets/images/sound-off_dark.svg);\r\n  }\r\n\r\n  .button__audio_on {\r\n    background: url(../assets/images/sound-on_dark.svg);\r\n  }\r\n\r\n  .button__theme_dark {\r\n    background: url(../assets/images/theme-dark.svg);\r\n  }\r\n\r\n  .cell_crossed {\r\n    background: url(../assets/images/cross_dark.svg);\r\n    background-color: getColor(cell-primary);\r\n  }\r\n}\r\n\r\n","%cluesBackground {\r\n  position: absolute;\r\n  bottom: 0;\r\n\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n  border-radius: 20px;\r\n}\r\n\r\n%fieldBackground {\r\n  opacity: 0.5;\r\n  border-radius: $radius-game-field;\r\n  box-shadow: getShadow(primary);\r\n}\r\n\r\n",".main {\r\n  @include flexPosition();\r\n  flex-direction: column;\r\n  height: $height-page;\r\n\r\n  @media (max-width: $tablet-width) {\r\n    height: 100svh;\r\n  }\r\n\r\n  @media (max-width: $tablet-width) and (orientation: landscape) {\r\n    width: 100dvw;\r\n    margin: 30px 0;\r\n  }\r\n\r\n  @media screen and (orientation: portrait) and (min-width: $mobile-big-width) and (max-width: $content-width) {\r\n    justify-content: end;\r\n  }\r\n\r\n  @media screen and (min-height: 1025px) {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n.background {\r\n  background-image: url(../assets/images/background.jpg);\r\n  background-size: cover;\r\n  height: 100%;\r\n  width: 100%;\r\n\r\n  opacity: 0.9;\r\n  top: 0;\r\n  position: fixed;\r\n  z-index: -1;\r\n}\r\n\r\n.main__header {\r\n  display: flex;\r\n  gap: 2rem;\r\n}\r\n\r\n.main__header_win {\r\n  text-shadow: 1px -1px #ffffff;\r\n  scale: (1.2);\r\n  transition: all 1s cubic-bezier(0, -0.27, 1, 1.27);\r\n}\r\n","@mixin basicRectangle($height, $width, $color: none) {\r\n  height: $height;\r\n  width: $width;\r\n  background: $color;\r\n}\r\n\r\n@mixin flexPosition($align-items: center, $justify-content: center) {\r\n  display: flex;\r\n  align-items: $align-items;\r\n  justify-content: $justify-content;\r\n}\r\n\r\n",".menu {\r\n  display: grid;\r\n  row-gap: 2rem;\r\n\r\n  position: fixed;\r\n  top: 2vh;\r\n  left: 2vw;\r\n\r\n  @media screen and (orientation: portrait) and (max-width: $content-width) {\r\n    width: 65vw;\r\n    left: 4vw;\r\n  }\r\n}\r\n\r\n.menu__buttons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  width: $size-cell * 2;\r\n\r\n  @media screen and (orientation: portrait) and (max-width: $content-width) {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.menu__templates {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n\r\n  @media screen and (orientation: portrait) and (max-width: $content-width) {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 0.5fr 2fr;\r\n  }\r\n}\r\n\r\n",".header__text,\r\n.header__timer {\r\n  color: getColor(cell-hover);\r\n  transition: all 1s cubic-bezier(0, -0.27, 1, 1.27);\r\n}\r\n",".templates__sizes,\r\n.templates__names,\r\n.templates__wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  justify-content: space-between;\r\n  opacity: 1;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.templates__wrapper {\r\n  position: relative;\r\n  @media screen and (orientation: portrait) and (max-width: $content-width) {\r\n    overflow-y: hidden;\r\n  }\r\n}\r\n\r\n.templates__sizes_hidden,\r\n.templates__names_hidden {\r\n  position: absolute;\r\n  width: 100%;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n.templates__wrapper_hidden {\r\n  opacity: 0;\r\n}\r\n\r\n.templates__sizes,\r\n.templates__names {\r\n  @media screen and (orientation: portrait) and (max-width: $content-width) {\r\n    flex-direction: row;\r\n    overflow-y: hidden;\r\n  }\r\n}\r\n\r\n",".button {\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      transform: scale(1.2);\r\n    }\r\n\r\n    &:active {\r\n      transform: scale(1);\r\n    }\r\n  }\r\n}\r\n\r\n.settings {\r\n  position: fixed;\r\n  top: 2vh;\r\n  right: 2vw;\r\n  display: flex;\r\n  gap: 2rem;\r\n}\r\n\r\n.button__audio_off {\r\n  @include basicRectangle(\r\n    $size-cell / 2,\r\n    $size-cell / 2,\r\n    url(../assets/images/sound-off.svg)\r\n  );\r\n}\r\n\r\n.button__audio_on {\r\n  background: url(../assets/images/sound-on.svg);\r\n}\r\n\r\n.button__theme_light {\r\n  @include basicRectangle(\r\n    $size-cell / 2,\r\n    $size-cell / 2,\r\n    url(../assets/images/theme-light.svg)\r\n  );\r\n}\r\n\r\n.button__menu,\r\n.button__templates {\r\n  @include basicRectangle($size-cell / 2, $size-cell / 1.8);\r\n\r\n  border-radius: 100px;\r\n  color: getColor(cell-additional);\r\n  border: $border-cell solid getColor(cell-additional);\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  &:active {\r\n    box-shadow: getShadow(button);\r\n  }\r\n}\r\n\r\n.button__templates {\r\n  width: 100%;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      transform: scale(1.1);\r\n    }\r\n\r\n    &:active {\r\n      transform: scale(1);\r\n    }\r\n  }\r\n}\r\n",".divider-vertical {\r\n  @include basicRectangle($size-game-field, 1px, getColor(back));\r\n}\r\n\r\n.divider-horizontal {\r\n  @include basicRectangle(1px, $size-game-field, getColor(back));\r\n}\r\n\r\n",".cell {\r\n  @include basicRectangle($size-cell, $size-cell, getColor(cell-primary));\r\n\r\n  border: $border-cell solid getColor(cell-additional);\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.4s ease;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      z-index: 2;\r\n      transform: scale(1.1);\r\n      outline: $border-cell solid getColor(back);\r\n      box-shadow: getShadow(cell);\r\n    }\r\n\r\n    &:active {\r\n      transform: scale((1));\r\n    }\r\n\r\n    &:not(:hover) {\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: $tablet-width) {\r\n    height: 14vw;\r\n  }\r\n\r\n  @media screen and (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    height: 14vh;\r\n    width: 9vw;\r\n  }\r\n}\r\n\r\n.cell_pressed {\r\n  background: getColor(cell-hover);\r\n  outline: $border-cell solid getColor(back);\r\n}\r\n\r\n.cell_crossed {\r\n  background: url(../assets/images/cross.svg);\r\n  background-color: getColor(cell-primary);\r\n\r\n  &:hover {\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.cell_clue {\r\n  @include basicRectangle($size-cell, $size-cell);\r\n  border: 1px solid getColor(back);\r\n  text-align: center;\r\n  color: getColor(back);\r\n\r\n  display: inline-grid;\r\n  align-items: center;\r\n\r\n  @media screen and (max-width: $tablet-width) {\r\n    height: 14vw;\r\n  }\r\n\r\n  @media screen and (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    height: 14vh;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.horizontal {\r\n  display: inline-flex;\r\n  justify-content: space-around;\r\n}\r\n",".gameField {\r\n  @include basicRectangle(\r\n    $size-game-field,\r\n    $size-game-field,\r\n    getColor(cell-hover)\r\n  );\r\n  @include flexPosition(end, right);\r\n  @extend %fieldBackground;\r\n\r\n  position: relative;\r\n  margin: 3rem;\r\n  transition: all 0.3s;\r\n\r\n  @media (orientation: portrait) and (max-width: $tablet-width) {\r\n    width: 80vw;\r\n    height: auto;\r\n  }\r\n\r\n  @media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    height: 90dvh;\r\n  }\r\n\r\n  @media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    height: 90dvh;\r\n    width: 54vw;\r\n  }\r\n}\r\n\r\n.gameField_closed {\r\n  opacity: 0;\r\n}\r\n\r\n.gameField__cells {\r\n  border-collapse: collapse;\r\n  border: $border-table solid getColor(back);\r\n\r\n  @media screen and (max-width: $tablet-width) {\r\n    width: 85%;\r\n    position: absolute;\r\n  }\r\n  @media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    width: unset;\r\n  }\r\n}\r\n\r\n.gameField__clues-wrapper {\r\n  position: absolute;\r\n  z-index: -1;\r\n  max-height: 100%;\r\n\r\n  @media (max-width: $tablet-width) {\r\n    position: unset;\r\n  }\r\n\r\n  @media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.gameField__clues {\r\n  border-collapse: collapse;\r\n  font-size: 3rem;\r\n\r\n  @media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (orientation: portrait) and (max-width: $tablet-width) {\r\n  .gameField__clues tr {\r\n    width: 80vw;\r\n    display: flex;\r\n  }\r\n}\r\n\r\n@media (orientation: landscape) and (max-width: $tablet-landscape-width) and (max-height: $mobile-big-landscape-height) {\r\n  .gameField__clues tr {\r\n    display: flex;\r\n  }\r\n}\r\n",".modal {\r\n  display: none;\r\n}\r\n\r\n.modal_open {\r\n  display: block;\r\n}\r\n\r\n.modal__overlay {\r\n  cursor: pointer;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  background: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.modal__window {\r\n  position: fixed;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n\r\n  @include basicRectangle($size-game-field, $size-game-field, getColor(modal));\r\n\r\n  @include flexPosition(center, left);\r\n  flex-direction: column;\r\n\r\n  @extend %fieldBackground;\r\n  color: getColor(cell-hover);\r\n}\r\n\r\n.window__line {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n}\r\n\r\n.window__line_main {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
